import navigation from "./navigation.module.css";
import {Link} from "react-router-dom";
function Sidebar() {
    return (
        <div className={navigation.sidebar}>
        </div>
    )
}
export default Sidebar;
